import { cCode_to_nation } from "../Utils/numberUtils.js";

const MEMBER_ACTION_COLUMN_WIDTH_COMPACT = "72px";
const MEMBER_ACTION_COLUMN_WIDTH_EDITING = "190px";

export const buildMemberColumns = ({
  clickAndEdit,
  canManageDepartmentAndRelation,
  hasEditingMember,
  showSecretCode,
}) => [
  ...(clickAndEdit
    ? [{ key: "select", type: "select", width: "50px", align: "center" }]
    : []),
  { key: "no", label: "NO", width: "78px", align: "center" },
  { key: "ranking", label: "랭킹", width: "96px", align: "center" },
  ...(showSecretCode
    ? [{ key: "secretCode", label: "코드", width: "112px", align: "leftalign" }]
    : []),
  { key: "departmentName", label: "부서명", width: "188px", align: "leftalign" },
  { key: "nickName", label: "닉네임", width: "144px", align: "leftalign" },
  {
    key: "email",
    label: "이메일",
    width: canManageDepartmentAndRelation ? "240px" : "248px",
    align: "leftalign",
  },
  {
    key: "totalStep",
    label: "조회 기간 걸음 수",
    width: "136px",
    align: "leftalign",
  },
  {
    key: "prevMonthStep",
    label: "지난달 누적 걸음 수",
    width: "136px",
    align: "leftalign",
  },
  {
    key: "currentMonthStep",
    label: "이번달 누적 걸음 수",
    width: "136px",
    align: "leftalign",
  },
  { key: "regTime", label: "승인 날짜", width: "168px", align: "leftalign" },
  { key: "nation", label: "국가", width: "92px", align: "leftalign" },
  ...(canManageDepartmentAndRelation
    ? [{ key: "relation", label: "관계", width: "110px", align: "leftalign" }]
    : []),
  ...(!clickAndEdit
    ? [
        {
          key: "actions",
          type: "actions",
          width: hasEditingMember
            ? MEMBER_ACTION_COLUMN_WIDTH_EDITING
            : MEMBER_ACTION_COLUMN_WIDTH_COMPACT,
        },
      ]
    : []),
];

export const getMemberGridTemplate = (columns) =>
  columns.map((column) => column.width).join(" ");

const parseColumnMinWidth = (width) => {
  const fixedWidthMatch = width.match(/^(\d+)px$/);

  if (fixedWidthMatch) {
    return Number(fixedWidthMatch[1]);
  }

  return 0;
};

export const getMemberTableMinWidth = (columns) =>
  `${columns.reduce(
    (totalWidth, column) => totalWidth + parseColumnMinWidth(column.width),
    0
  )}px`;

export const buildMemberExcelColumns = ({
  canManageDepartmentAndRelation,
  showSecretCode,
}) =>
  buildMemberColumns({
    clickAndEdit: false,
    canManageDepartmentAndRelation,
    hasEditingMember: false,
    showSecretCode,
  }).filter((column) => column.type !== "actions" && column.type !== "select");

export const getMemberExcelCellValue = ({
  row,
  index,
  columnKey,
  maskEmail = false,
}) => {
  switch (columnKey) {
    case "no":
      return index + 1;
    case "ranking":
      return `${row.ranking}위`;
    case "secretCode":
      return row.secretCode ?? "";
    case "departmentName":
      return row.departmentName ? row.departmentName : "없음";
    case "nickName":
      return row.nickName;
    case "email":
      return maskEmail ? "-" : row.email ?? "";
    case "totalStep":
      return Number(row.totalStep ?? 0).toLocaleString();
    case "prevMonthStep":
      return Number(row.prevMonthStep ?? 0).toLocaleString();
    case "currentMonthStep":
      return Number(row.currentMonthStep ?? 0).toLocaleString();
    case "regTime":
      return row.regTime;
    case "nation":
      return cCode_to_nation(row.cCode);
    case "relation":
      return row.memberType === 1 ? "임직원" : row.memberType === 2 ? "지인" : "-";
    default:
      return "";
  }
};
